import { adminHttpClient } from '../../../../../commons/adminHttpClient'

export type PerksClassTypes = {
  id: number
  name: string
  isCustom: boolean
}
export const getPerksClassTypes = (planPeriod: string): Promise<PerksClassTypes[]> => {
  return adminHttpClient.get(`/AdminDashboard/Perks/ClassDesign/ClassTypes/${planPeriod}`)
}
